import { trackDealerProfileSettings } from './tracking';

export const DEALER_PROFILE_SETTINGS_TRACKING = {
  trackDealerProfileSettings,
};
